// extracted by mini-css-extract-plugin
export var label = "_fg-0";
export var treatmentCard = "_fg-1";